/*
The following globals are defined outside of this file. For example, in template.php.
These globals need to be set to pass linter requirements.
*/
/* global M */
/* global BASE_URL */
/* global PAGE_TITLE_POSTFIX */
/* global translations */
/* global pageRequestTime */
/* global warning */
/* global warningTime */
/* global warningStarted */
/* global timeoutLength */
/* global countdownTime */
/* global sessionLength */

import { heicTo } from "heic-to"

// jQuery plugin for preloading images
$.fn.preload = function (callback) {
  const length = this.length
  let iterator = 0

  return this.each(function () {
    const self = this
    const tmp = new Image()

    if (callback) {
      tmp.onload = function () {
        callback.call(self, 100 * ++iterator / length, iterator === length)
      }
    }

    tmp.src = this.src
  })
}

/**
 * Javascript templating (as a jQuery plugin)
 *
 * See: https://johnresig.com/blog/javascript-micro-templating/
 */
$.fn.tmpl = function (templateId, data) {
  const cache = {}

  function tmpl (str, data) {
    // Figure out if we're getting a template, or if we need to
    // load the template - and be sure to cache the result.
    const fn = !/[^\w_-]/.test(str)
      ? (cache[str] = cache[str] || tmpl(document.getElementById(str).innerHTML))
      // Generate a reusable function that will serve as a template
      // generator (and which will be cached).
      // eslint-disable-next-line no-new-func
      : new Function('obj',
        'var p=[],print=function(){p.push.apply(p,arguments);};' +

        // Introduce the data as local variables using with(){}
        "with(obj){p.push('" +

        // Convert the template into pure JavaScript
        str
          .replace(/[\r\t\n]/g, " ")
          .split("<%").join("\t")
          .replace(/((^|%>)[^\t]*)'/g, "$1\r")
          .replace(/\t=(.*?)%>/g, "',$1,'")
          .split("\t").join("');")
          .split("%>").join("p.push('")
          .split("\r").join("\\'") +

        "');}return p.join('');"
      )

    // Provide some basic currying to the user
    return data ? fn(data) : fn
  }

  const html = tmpl(templateId, data)

  $(this).html(html)

  return this
}

$.fn.stepper = function () {
  const stepper = $(this)

  if (!stepper || !stepper.length) {
    return this
  }

  let activeItem = stepper.find('li.active')

  function goToItem (item) {
    stepper.find('li.active').removeClass('active')
    item.addClass('active')

    const id = item.find('a').attr('href')

    $('.stepper-content').hide()
    $(id).show()

    const prevButtonOn = !!item.prev().length
    const nextButtonOn = !!item.next().length

    togglePrevButton(prevButtonOn)
    toggleNextButton(nextButtonOn)

    activeItem = item

    if (hasNextItem(item)) {
      toggleFinishButton(false)
    }

    return item
  }

  function goToNextItem () {
    const item = activeItem.next()
    goToItem(item)
  }

  function goToPrevItem () {
    const item = activeItem.prev()
    goToItem(item)
  }

  function toggleNextButton (on) {
    $('.stepper-next').attr('disabled', !on)

    if (!on) {
      toggleFinishButton(true)
    }
  }

  function togglePrevButton (on) {
    $('.stepper-prev').attr('disabled', !on)
  }

  function hasNextItem (currentItem) {
    return !!currentItem.next().length
  }

  function toggleFinishButton (on) {
    if (on) {
      $('.stepper-next').hide()
      $('.stepper-finish').show()
    } else {
      $('.stepper-finish').hide()
      $('.stepper-next').show()
    }
  }

  function init () {
    if (!activeItem.length) {
      activeItem = stepper.find('li:first-child')
    }

    togglePrevButton(false)

    const items = stepper.find('li')

    if (items <= 1) {
      toggleNextButton(false)
      toggleFinishButton(true)
    }
  }

  init()

  stepper.find('a').on('click', function (event) {
    event.preventDefault()
    goToItem($(this).parents('li'))
  })

  $('.stepper-next').on('click', goToNextItem)
  $('.stepper-prev').on('click', goToPrevItem)

  return this
}

window.setPageTitle = function (title, append = '') {
  document.title = `${title}${append || PAGE_TITLE_POSTFIX}`
}

window.readableFileSize = function (size) {
  const defaultSize = 0
  const fileSize = size ?? defaultSize

  if (!fileSize) {
    return `${defaultSize} KB`
  }

  const sizeInKb = fileSize / 1024

  if (sizeInKb > 1024) {
    return `${(sizeInKb / 1024).toFixed(2)} MB`
  }

  return `${sizeInKb.toFixed(2)} KB`
}

window.renewSession = function () {
  $.get(BASE_URL + '/index.php?renew_session=1', function () {
    window.restartSessionTimeValues()
    window.closeModal('#sessionModal')
  })
}

window.modals = {}

window.openModal = function (el) {
  if (!window.modals[el]) {
    window.modals[el] = M.Modal.init(document.querySelector(el))
  }

  if (window.modals[el]) {
    return window.modals[el].open()
  }
}

window.closeModal = function (el) {
  if (!window.modals[el]) {
    return false
  }

  return window.modals[el].close()
}

window.isMobile = function () {
  let check = false;

  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) {
      check = true
    }
  })(navigator.userAgent || navigator.vendor || window.opera)

  return check
}

window.isMobileOrTablet = function () {
  let check = false;

  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) {
      check = true
    }
  })(navigator.userAgent || navigator.vendor || window.opera)

  return check
}

window.ajaxCall = function (url, updateElement, data, loadingMessage, inModal, skipUrlManipulation, onCompleteCallback) {
  $.ajaxSetup({
    cache: false
  })

  if (loadingMessage) {
    window.showLoadingScreen(loadingMessage)
  }

  if (data) {
    $.post(url, data).done(function (html) {
      $(updateElement).html(html)
      window.hideLoadingScreen()
    }).fail(function () {
      alert((translations.some_wrong ? translations.some_wrong : 'Something went wrong, please try again.'))
    })
  } else {
    $.ajax({
      url,
      cache: false
    }).done(function (html) {
      window.hideLoadingScreen()
      if (updateElement) {
        $(updateElement).html(html)
      }
    })
  }

  if (!skipUrlManipulation && url !== window.location && window.history.pushState) {
    window.history.pushState({ path: url }, '', url)

    $(window).bind('popstate', function () {
      $.ajax({
        url: location.pathname,
        success: function (data) {
          $('#content').html(data)
        }
      })
    })
  }

  if (inModal) {
    window.openModal('#ajaxModal')
  }

  if (onCompleteCallback) {
    onCompleteCallback()
  }
}

window.cardIdChanged = function () {
  if ($('#CardId').val() !== '') {
    $('#RequestReason').focus()
  }
}

window.showErrorMessage = function (text, hideButton, scrollToTop) {
  if ($('#messages').length) {
    const flash = $('<div></div>')
      .addClass(['flash danger'])
      .attr({ role: 'alert' })

    flash.append(text)
    if (!hideButton) {
      const btn = $('<button type="button" class="btn filled btn-icon text close" data-dismiss="alert" aria-label="Sluiten"><i class="icon icon-24 material-symbols-outlined ">close</i></button>')
      flash.append(btn)
    }

    $('#messages').append(flash)

    if (scrollToTop) {
      window.scrollTo('messages')
    }
  } else {
    alert(text)
  }
}

window.resizeImageBeforeUpload = async function (fileElement, fileDataElement, allowedTypes, allowedTypesError, $form, maxWidth, maxHeight) {
  let item = document.querySelector(fileElement).files[0]
  // console.log('resizeImageBeforeUpload', item)

  let typeAllowed = false
  if (await HeicTo.isHeic(item)) {
    const jpeg = await heicTo({
      blob: item,
      type: "image/jpeg",
      quality: 0.9
    })
    jpeg.name = item.name
    item = jpeg
    typeAllowed = true
  } else {
    const types = JSON.parse(allowedTypes)
    for (let i = 0; i < types.length; i++) {
      if (item.type === types[i]) {
        typeAllowed = true
      }
    }
  }

  if (!typeAllowed) {
    window.showErrorMessage(allowedTypesError, false, true)
    $(fileElement).val('')
    return
  }

  const reader = new FileReader()

  // image turned to base64-encoded Data URI.
  reader.readAsDataURL(item)
  reader.name = item.name
  reader.size = item.size
  reader.onload = function (event) {
    const img = new Image()
    img.src = event.target.result// result is base64-encoded Data URI
    img.name = event.target.name
    img.size = event.target.size
    img.onload = function (el) {
      const elem = document.createElement('canvas')

      if (el.target.height > el.target.width && maxHeight < el.target.height) {
        const scaleFactor = maxHeight / el.target.height
        elem.height = maxHeight
        elem.width = el.target.width * scaleFactor
      } else if (maxWidth < el.target.width) {
        const scaleFactor = maxWidth / el.target.width
        elem.width = maxWidth
        elem.height = el.target.height * scaleFactor
      } else {
        elem.width = el.target.width
        elem.height = el.target.height
      }

      const ctx = elem.getContext('2d')
      ctx.drawImage(el.target, 0, 0, elem.width, elem.height)
      const srcEncoded = ctx.canvas.toDataURL(item.type, 1)
      $(fileElement).val('')
      $(fileDataElement).val(srcEncoded)
      $form.form.submit()
    }
  }
}

window.setAutoFocusForRequestAndHandleForm = function () {
  $('#card-action-form').submit(function (event) {
    let valid = true

    if ($('#CardId').length > 0) {
      if ($('#CardId').val().replace(/\r\n|\r|\n|\t| /g, '') === '') {
        event.preventDefault()
        valid = false
        $('#CardId').parent().addClass('has-error bg-danger')
      } else {
        $('#CardId').parent().removeClass('has-error bg-danger')
      }
    }

    if ($('#RequestReason').val().replace(/\r\n|\r|\n|\t| /g, '', '') === '') {
      $('#RequestReason').val('')
      event.preventDefault()
      valid = false
      $('#RequestReason').parent().addClass('has-error bg-danger')
    } else {
      $('#RequestReason').parent().removeClass('has-error bg-danger')
    }

    if (valid) {
      window.showLoadingScreen(translations.saving)
    }
  })
}

window.clearMessages = function () {
  $('#messages').html('')
}

window.removeParamsFromUrl = function () {
  if (window.history.pushState) {
    window.history.pushState({ path: BASE_URL }, '', BASE_URL)
  }
}

window.showLoadingScreen = function (msg) {
  if (!msg) {
    msg = (translations.loading ? translations.loading : 'Loading...')
  }

  $('#loading-overlay').fadeIn({ duration: 400 })
  $('#loading-box').delay(250).fadeIn({ duration: 250 })
  $('#loading-text').html(msg)
}

window.hideLoadingScreen = function () {
  if ($('#loading-overlay').is(':visible')) {
    $('#loading-overlay').delay(150).fadeOut({ duration: 250 })
    $('#loading-box').fadeOut({ duration: 250 })
  }
}

window.countdownTickerEvent = null

window.checkSessionTime = function () {
  const timeNow = new Date()
  let timeDifference = 0

  timeDifference = timeNow - pageRequestTime

  if (warning > 0 && timeDifference > warningTime && warningStarted === false) {
    window.PageTitleNotification.On((translations.warning ? translations.warning : 'Warning'))
    window.countdownTicker()

    window.countdownTickerEvent = setInterval(window.countdownTicker, 1000)

    window.openModal('#sessionModal')

    warningStarted = true
  } else if (timeDifference > timeoutLength) {
    if (window.countdownTickerEvent !== null) {
      clearInterval(window.countdownTickerEvent)
    }

    window.redirectTo(BASE_URL + '/index.php?expired')
  }
}

window.restartSessionTimeValues = function () {
  pageRequestTime = new Date()
  warningStarted = false
  countdownTime = warning

  window.PageTitleNotification.Off()

  if (window.countdownTickerEvent !== null) {
    clearInterval(window.countdownTickerEvent)
  }
}

window.countdownTicker = function () {
  // Put countdown time left in dialog box
  let minutes = 0
  let seconds = 0

  if (countdownTime > 60) {
    minutes = Math.floor(countdownTime / 60)
    seconds = countdownTime % 60
  }

  const secondsElement = $('div#session-expire-in-seconds')
  const minutesElement = $('div#session-expire-in-minutes')

  if (minutes > 0) {
    if (secondsElement.is(':visible')) {
      secondsElement.hide()
    }

    if (!minutesElement.is(':visible')) {
      minutesElement.show()
    }

    minutesElement.find('span.session-time-minutes-left').html(minutes)
    minutesElement.find('span.session-time-left').html(seconds)
  } else {
    if (minutesElement.is(':visible')) {
      minutesElement.hide()
    }

    if (!secondsElement.is(':visible')) {
      secondsElement.show()
    }

    secondsElement.find('span.session-time-left').html(countdownTime)
  }

  countdownTime--
}

window.redirectTo = function (url) {
  window.location.href = url
}

window.scrollTo = function (elementId) {
  $('html, body').animate({
    scrollTop: $('#' + elementId).offset().top
  }, 300)
}

window.PageTitleNotification = {
  Vars: {
    OriginalTitle: document.title,
    Interval: null
  },
  On: function (notification, intervalSpeed) {
    const _this = this
    _this.Vars.Interval = setInterval(function () {
      document.title = (_this.Vars.OriginalTitle === document.title) ? notification : _this.Vars.OriginalTitle
    }, intervalSpeed || 1000)
  },
  Off: function () {
    clearInterval(this.Vars.Interval)
    document.title = this.Vars.OriginalTitle
  }
}

window.detectIE = function () {
  const ua = window.navigator.userAgent

  const msie = ua.indexOf('MSIE ')
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
  }

  const trident = ua.indexOf('Trident/')
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:')
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
  }

  const edge = ua.indexOf('Edge/')
  if (edge > 0) {
    // IE 12 => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
  }

  // Other browser
  return false
}

window.setCookie = function (name, value, exdays, path) {
  const exdate = new Date()
  exdate.setDate(exdate.getDate() + exdays)

  const cookieValue = escape(value) + (
    (exdays == null) ? '' : ';' + 'expires=' + exdate.toUTCString()
  ) + ';' + 'path=' + path

  document.cookie = name + '=' + cookieValue
}

window.toggleDeleteNotificationsButton = function () {
  const deleteNotificationsButton = $('#delete-notifications')
  const selects = $('.notification-select')
  const hasSelected = []

  selects.each(function (index, item) {
    if (item.checked) {
      hasSelected.push(item)
    }
  })

  if (hasSelected.length) {
    return deleteNotificationsButton.show()
  }

  return deleteNotificationsButton.hide()
}

window.toggleSelectionMessage = function () {
  let counter = 0

  const container = $('.selection-message-container')
  const counterContainer = container.find('.selection-count')
  const selectionSelector = counterContainer.first().data('selection-selector')

  $(selectionSelector).each((i, el) => {
    return el.checked ? counter++ : null
  })

  const selectionCountText = counter > 0 ? `(${counter})` : ''

  container.toggleClass('active')
  counterContainer.text(selectionCountText)
}

$(function () {
  const sidenav = M.Sidenav.init(document.querySelector('#sidenav'))
  M.FormSelect.init(document.querySelectorAll('select'))
  M.Tooltip.init(document.querySelectorAll('.tooltipped'))

  $('.sidenav-close').on('click', function () {
    sidenav.close()
  })

  $('input.select-all').on('click', function () {
    const self = $(this)
    const target = self.data('select-all-target')

    const isChecked = self.prop('checked')

    $(target).prop('checked', isChecked)

    window.toggleDeleteNotificationsButton()
    window.toggleSelectionMessage()
  })

  $('#notifications-form').on('submit', function (event) {
    event.preventDefault()

    const self = $(this)
    const action = self.attr('action')
    const data = self.serialize()
    const loadingMessage = self.data('loading-message')

    window.ajaxCall(action, '#ajaxModalContent', data, loadingMessage, false, true)
  })

  $('.notification-container').on('click', function () {
    const self = $(this)
    const id = self.data('id')
    const isUnread = self.hasClass('unread')

    if (isUnread) {
      window.ajaxCall(BASE_URL + '/index.php?read_notification=' + id, '#ajaxModalContent', null, null, false, true)
    }
  })

  $('.notification-select').on('click', function () {
    window.toggleDeleteNotificationsButton()
    window.toggleSelectionMessage()
  })

  $('#delete-notifications').on('click', function (event) {
    event.preventDefault()

    $('#notifications-form').submit()
  })

  $('.stepper').stepper()

  $('.preview-file').on('change', function (event) {
    const self = $(this)
    const files = event.target.files
    const data = []
    const previewId = self.data('previewId')
    const templateId = self.data('templateId')

    $.each(files, (index, file) => {
      const isImage = file.type.indexOf('image/') === 0
      const normalizedImage = {
        name: file.name,
        type: file.type,
        size: file.size,
        readableSize: window.readableFileSize(file.size),
        src: null
      }

      if (isImage) {
        normalizedImage.src = URL.createObjectURL(file)
      }

      data.push(normalizedImage)
    })

    $(`#${previewId}`).tmpl(templateId, { files: data })
  })

  $('body').on('click', '.flash .close', function () {
    $(this).parent('.flash').hide()
  })

  if (typeof sessionLength !== 'undefined' && sessionLength > 0) {
    setInterval(window.checkSessionTime, 1 * 1000)
  }
})

// Needed when user clicks on previous page button in browser
window.hideLoadingScreen()
